/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Create_Dedup_MessageInputs */



/**
* | output |
* | --- |
* | "These members look similar. Register one of them, or create a new account if none match." |
*
* @param {Create_Dedup_MessageInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const create_dedup_message = /** @type {((inputs?: Create_Dedup_MessageInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Create_Dedup_MessageInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ces membres semblent similaires. Inscrivez l'un d'eux, ou créez un nouveau compte si aucun ne correspond.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Estos miembros parecen similares. Inscriba a uno de ellos, o cree una cuenta nueva si ninguno coincide.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Estes membros parecem similares. Inscreva um deles, ou crie uma nova conta se nenhum corresponder.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Questi membri sembrano simili. Iscrivi uno di loro, oppure crea un nuovo account se nessuno corrisponde.")
	return /** @type {LocalizedString} */ ("These members look similar. Register one of them, or create a new account if none match.")
});